var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef } from "react";
import { useDebounce } from "@/06-shared/lib/useDebounce";
import { saveDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
export const useAutoSaveDocument = ({ content, documentId, debounceMs = 1000, enabled = true, }) => {
    const debouncedContent = useDebounce(content, debounceMs);
    const savedContentRef = useRef(null);
    const documentIdRef = useRef(documentId);
    const showError = useNotifyError();
    useEffect(() => {
        if (documentIdRef.current !== documentId) {
            documentIdRef.current = documentId;
            savedContentRef.current = null;
        }
        if (!enabled) {
            savedContentRef.current = null;
            return;
        }
        if (savedContentRef.current === null) {
            savedContentRef.current = content;
            return;
        }
        if (debouncedContent === savedContentRef.current) {
            return;
        }
        const saveDoc = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield saveDocument({
                    content: debouncedContent,
                    docId: documentId,
                });
                savedContentRef.current = debouncedContent;
            }
            catch (error) {
                showError(error);
            }
        });
        saveDoc();
    }, [debouncedContent, documentId, enabled]);
};
